import { useEffect, useState } from 'react';
import * as domainApi from '../lib/api/domain';

const normalizeLink = (link) => {
  if (!link) return '';
  const trimmed = String(link).startsWith('/') ? String(link).slice(1) : String(link);
  return trimmed.replace(/\/$/, '');
};

/**
 * SYS_MENU_AUTH 기반 "이 메뉴를 쓸 수 있는가" - domainApi.checkAuth() (= /api/v1/sys/auth/check/auth,
 * 드로어 메뉴(MenuList.js)가 쓰는 그 응답)로 로그인 사용자가 볼 수 있는 메뉴 목록을 받아, 주어진
 * link 가 그 안에 있는지만 본다.
 *
 * ⚠️ 한계: 이 프로젝트의 메뉴 권한은 메뉴 단위로 "접근 가능/불가" 하나뿐이고, 읽기/쓰기를 나누는
 * 별도 플래그가 없다(authmenumng 화면도 메뉴마다 체크박스 하나). 그래서 이 훅이 돌려주는 값은
 * "이 메뉴 쓰기 권한"이 아니라 "이 메뉴에 접근 가능한가"다 - 장비관리 메뉴 자체에 접근 못 하면
 * 그 화면을 열 수조차 없으므로, 실제로 이 훅이 걸러내는 경우는 "메뉴에서는 빠졌지만(체크 해제)
 * 주소를 직접 입력해 들어온" 경우 정도다. 더 세밀한 쓰기 권한이 필요해지면 백엔드에 별도 플래그가
 * 있어야 한다.
 *
 * 조회 중/실패 시에는 true(접근 가능)로 둔다 - 편집 버튼이 매번 깜빡이는 것을 피하고, 실제 쓰기는
 * 어차피 백엔드가 권한으로 막아주기 때문이다.
 */
export const useMenuAccess = (link) => {
  const [canAccess, setCanAccess] = useState(true);

  useEffect(() => {
    let active = true;
    domainApi.checkAuth()
      .then((res) => {
        if (!active) return;
        const groups = res?.data?.list || [];
        const flatLinks = [];
        groups.forEach((group) => {
          if (group?.link) flatLinks.push(normalizeLink(group.link));
          (group?.items || []).forEach((item) => {
            if (item?.link) flatLinks.push(normalizeLink(item.link));
          });
        });
        setCanAccess(flatLinks.includes(normalizeLink(link)));
      })
      .catch(() => {
        // 조회 실패 - 판단할 수 없으니 기존처럼 보여준다(백엔드가 실제 쓰기는 막아준다).
      });
    return () => { active = false; };
  }, [link]);

  return canAccess;
};

export default useMenuAccess;
